module.exports = __webpack_public_path__ + "img/icon-display.f1349351.svg";